export default __webpack_public_path__ + "static/flop-gto-logo-dark-aedfb0ffd5e241c023b038196fe352dc.png";